module.exports = __webpack_public_path__ + "media/icons/minus@3x-8216937a.svg";